import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/academic-years', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/academic-years/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/academic-years', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/academic-years/${data.ac_year_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/academic-years/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getStatus = (option = {}) => {
  return httpClient
    .get('/api/academic-years/statuses')
    .then(response => Promise.resolve(response.data))
    .catch(response => Promise.reject(response.data))
}

export default { get, find, store, update, destroy, getStatus }
